import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Clear';
import { AssetsFileResolver } from 'app-modules/application/containers/AssetsFileResolver';

// This component corresponds to WWW-941 and displays a full screen player on page load.
// it is triggered by the parameters fullscreen=true&utmCampaign=scener in the url
// Most of the expanded player is handled through the fullscreensplashpage prop which is triggered in
// application.jsx and passed down as a prop to expand the player css
// It is separate from fullscreen and internalfullscreen, though it shares some css
// The logic of this trigger is in application.jsx

const Wrapper = styled.div`
  opacity: ${({ isVisible }) => (isVisible ? '1' : '0')};
  padding: 20px;
  transition: opacity 0.2s linear, 0.15s linear;
  position: absolute;
  width: 100%;
  background: linear-gradient(
    0,
    rgba(0, 0, 0, 0) 0%,
    rgba(0, 0, 0, 0.4) 31%,
    rgba(0, 0, 0, 0.7) 80%,
    rgba(0, 0, 0, 1) 100%
  );
`;
const PlutoLogo = styled(AssetsFileResolver)`
  width: 110px;
  @media (min-width: 960px) {
    width: 130px;
  }
`;
const styles = {
  closeButton: {
    cursor: 'pointer',
    fontSize: 30,
    margin: 9,
    opacity: 0.5,
    position: 'absolute',
    right: 0,
    top: 0,
    zIndex: 30,
  },
};

const FullscreenSplashPageComponent = ({ classes, isVisible, exitFullscreenSplashPage }) => (
  <Wrapper isVisible={isVisible}>
    <PlutoLogo alt="Pluto TV logo" path="images/logo-new.svg" />
    <CloseIcon
      onClick={exitFullscreenSplashPage}
      aria-label="Close"
      className={classes.closeButton}
    />
  </Wrapper>
);

FullscreenSplashPageComponent.propTypes = {
  isVisible: PropTypes.bool,
  exitFullscreenSplashPage: PropTypes.func,
};

export const FullscreenSplashPage = withStyles(styles)(FullscreenSplashPageComponent);
